var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrendingUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0594 4.52414C13.2302 4.69499 13.2302 4.972 13.0594 5.14286L8.39269 9.80952C8.22184 9.98038 7.94483 9.98038 7.77397 9.80952L5.75 7.78555L2.55936 10.9762C2.3885 11.147 2.1115 11.147 1.94064 10.9762C1.76979 10.8053 1.76979 10.5283 1.94064 10.3575L5.44064 6.85747C5.6115 6.68662 5.8885 6.68662 6.05936 6.85747L8.08333 8.88144L12.4406 4.52414C12.6115 4.35328 12.8885 4.35328 13.0594 4.52414Z",
    fill: "#27A376"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22917 4.8335C8.22917 4.59187 8.42504 4.396 8.66667 4.396H12.75C12.9916 4.396 13.1875 4.59187 13.1875 4.8335V8.91683C13.1875 9.15845 12.9916 9.35433 12.75 9.35433C12.5084 9.35433 12.3125 9.15845 12.3125 8.91683V5.271H8.66667C8.42504 5.271 8.22917 5.07512 8.22917 4.8335Z",
    fill: "#27A376"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/trending-up.2856887982feb4d7728b10e188b15696.svg";
export { ForwardRef as ReactComponent };